import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { RegionService } from '../../services/region/region.service';
import { Region } from '../../model/region.model';
import 'rxjs/add/operator/map';
import { LicenseDataService } from '../../services/agentLicense/license-data.service';
import { InsuranceService } from '../../services/insurance/insurance.service';
import { UploadService } from '../../services/upload/upload.service';
import { documentInformation } from '../../model/document.model';
import { FormBuilder, FormControl } from '@angular/forms';
import { SearchTermservice } from '../../services/search/search-service.service';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Router } from '@angular/router';
import { ChangeLogService } from '../../services/change_log/change-log.service';
import * as momenttimezone from 'moment-timezone';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';
import { StatesService } from '../../services/states/states.service';
@Component({
  selector: 'app-license-dialogue',
  templateUrl: './license-dialogue.component.html',
  styleUrls: ['./license-dialogue.component.css']
})
export class LicenseDialogueComponent implements OnInit {
  logFormData: any;
  allStates: Array<any> = [];
  selectedRegion: any;
  regions: Array<any> = [];
  onChangeFile: boolean = false;
  isFileChanged: boolean = false;
  states = [];
  response = [];
  region = new Region();
  data = {
    issuedate: Date,
    issuestate: '',
    licensenumber: '',
    expirationdate: Date,
    fileName: '',
    docid: '',
    documentType: '',
    documentName: '',
    MasterVendorId: '',
    VendorLicenseId: '',
    uploadDate: new Date(),
    documentLink: '',
    delete: 0,
    fileUpdated: false
  }
  minDate = new Date();
  statesList: any = [];
  externalURL: any;
  documentInfo: documentInformation = new documentInformation();
  updateFile: boolean = false;
  chooseFile: boolean = false;
  onChangeFileName: any;
  date;
  submitSuccess: boolean;
  errorMsg: boolean = false;
  isdatewrong: boolean;
  datewrongmsg: string;
  loginId: any;
  MasterVendorId: any;
  errorMessage: String = '';
  errorEnable: boolean = false;
  vendorName;
  uploadFlag: boolean = true;
  matSpinner: boolean = false;
  signedUrl;
  newFilePath;
  newFilePath1;
  firstName;
  lastName;
  previousValues: any = [];
  constructor(
    private statesService:StatesService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private changelogservice: ChangeLogService,
    private uploadService: UploadService,
    public insuranceservice: InsuranceService,
    public dialogRef: MatDialogRef<LicenseDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public licenseData: any,
    private regionService: RegionService,
    private http: Http, private router: Router,
    public fb: FormBuilder,
    public search: SearchTermservice,
    public licenseService: LicenseDataService, public ref: ChangeDetectorRef) {
    this.date = new FormControl(new Date());

  }

  ngOnInit() {
    this.loginId = localStorage.getItem('loginID');
    this.MasterVendorId = localStorage.getItem("AgentId");
    this.vendorName = localStorage.getItem('AgentName');
    this.firstName =  localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
    this.statesService.getStates().subscribe(res => {
      this.statesList = res.States;
      this.statesList.forEach(state => {
        this.states.push(state.Code);
      });
    }, error => {
      this.errorMessage = "All States: " + error;
      this.errorEnable = true;
      this.scrollTop();
    })
    this.data.MasterVendorId = this.licenseData.data.MasterVendorId;
    this.data.VendorLicenseId = this.licenseData.data.VendorLicenseId;
    this.data.documentName = this.licenseData.data.DocumentTypeName;
    this.data.docid = this.licenseData.data._id;
    this.data.documentType = this.licenseData.data.DocumentTypeCode;
    this.data.fileName = this.licenseData.data.FileName;
    if (this.licenseData.type === "update") {
      this.chooseFile = false;
      this.updateFile = true;
      this.onChangeFile = true;
      this.data.fileName = this.licenseData.data.FileName;
      this.data.expirationdate = this.licenseData.data.ExpirationDate;
      this.data.issuedate = this.licenseData.data.IssueDate;
      this.data.issuestate = this.licenseData.data.IssueState;
      this.data.licensenumber = this.licenseData.data.LicenseNumber;
      this.data.docid = this.licenseData.data._id;
      this.data.documentLink = this.licenseData.data.DocumentLink;
      this.data.documentName = this.licenseData.data.DocumentTypeName;
      this.data.documentType = this.licenseData.data.DocumentTypeCode;
      this.data.uploadDate = new Date();
    } else if (this.licenseData.type === 'create') {
      this.chooseFile = true;
      this.updateFile = false;
    }
  }

  scrollTop() {
    const element = document.getElementById('scrollToTop');
    element.scrollIntoView();
  }

  clear() {
    this.dialogRef.close();
  }

  setFileData(docInfo) {
    this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Upload a" + ' ' + this.licenseData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
    setTimeout(() => {
      this.documentInfo = docInfo;
      this.data.fileName = this.documentInfo.fileName;
      this.ref.markForCheck();
      this.ref.detectChanges()
    }, 100);
    // will be used to upload the file into amazon
    this.isFileChanged = true;
  }

  saveDocument() {
    this.matSpinner = true;
    this.uploadFlag = false;
    if (this.isFileChanged === false && this.licenseData.type === 'update') {
      this.externalURL = this.data.documentLink;
      this.submit();
    }
    else {
      let today = new Date();
      const estTimeZone = 'America/New_York';
      let uploadTimeZone = momenttimezone(today).tz(estTimeZone).format();
      uploadTimeZone = uploadTimeZone.replace(/[^a-zA-Z0-9]/g, '');
      var filePath = "Agent/" + this.data.MasterVendorId + "/licenseDocs/" + this.data.documentType + "/";
      this.data.fileName = this.documentInfo.fileName;
      let fileNameWithoutExt = this.documentInfo.fileName.substring(0, this.documentInfo.fileName.lastIndexOf('.'));
      let fileNameExt = this.documentInfo.fileName.substring(this.documentInfo.fileName.lastIndexOf('.') + 1, this.documentInfo.fileName.length);
      this.documentInfo.fileInput.append('url', filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt);
      this.newFilePath1 = filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt;
      let body = {
        "newFilePath" : this.newFilePath1,
        "vendor_id":this.MasterVendorId
      }
      this.uploadService.getSignedURL(body).subscribe((res) => {
       this.signedUrl = res.Info;
       this.uploadService.uploadDocumentWithSignedUrl(this.documentInfo.file, this.signedUrl).subscribe((obj) => {
        this.externalURL = this.newFilePath1;
        this.data.documentLink = this.externalURL;
        this.submit();
      });
      }, error => {
        this.errorEnable = true;
        this.errorMessage = "File upload: " + error;
        this.matSpinner = false;
        this.scrollTop();
      });
    }
  }

  submit() {
    this.submitSuccess = false;
    this.logFormData = {
      "document_type": this.licenseData.data.DocumentTypeName,
      "document_category": this.licenseData.data.DocumentCategory,
      "transaction_type": "Add",
      "vendor_id": this.MasterVendorId,
      "modified_by": this.loginId
    }

    if (this.licenseData.type === "create") {
      this.licenseService.createNewAgentLicense(this.data).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Create a" + ' ' + this.licenseData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
        this.submitSuccess = true;
        this.licenseService.load.next('success');
        this.dialogRef.close();
        this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
          this.errorMessage = err;
          this.errorEnable = true;
          this.matSpinner = false;
          this.scrollTop();
        });
      }, error => {
        this.submitSuccess = true;
        this.licenseService.load.next('fail')
        this.errorEnable = true;
        this.errorMessage = "Create license document: " + error;
        this.matSpinner = false;
        this.scrollTop();
      })
    } else {
      this.data.fileUpdated = this.isFileChanged;
      this.licenseService.updateAgentLicense(this.data).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Update a" + ' ' + this.licenseData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
        this.submitSuccess = true;
        this.licenseService.load.next('success');
        this.dialogRef.close();
        if (this.logFormData.transaction_type == "Add") {
          this.logFormData.transaction_type = "Edit";
          this.logFormData.document_category = this.licenseData.category;
          this.logFormData.vendor_id = this.licenseData.data.MasterVendorId;
          this.previousValues = localStorage.getItem('old');
            this.logFormData.previous_fields = JSON.parse(this.previousValues);
            this.logFormData.collection_name = "vendor_license_documents";
          this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
            this.errorMessage = err;
            this.errorEnable = true;
            this.matSpinner = false;
            this.scrollTop();
          });
        }
      }, error => {
        this.submitSuccess = true;
        this.licenseService.load.next('fail')
        this.errorMessage = "update license document: " + error;
        this.errorEnable = true;
        this.matSpinner = false;
        this.scrollTop();
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/components/license-dialogue/license-dialogue.component.ts